import React, { useCallback } from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import { payOrder } from "@/services/api/dropShipping/order";
import { useRequest } from "ahooks";
import { Button, message } from "antd";

interface PayOrderButtonProps {
    order: OrderDTO;

    onSuccess?(): void;
}

const PayOrderButton: React.FC<PayOrderButtonProps> = function (props) {
    const { order, onSuccess } = props;

    const request = useRequest(() => payOrder(order.shopId, order.id), { manual: true });

    const onPayClick = useCallback(async () => {
        try {
            await request.runAsync();

            onSuccess?.();

            message.success("支付成功");
        } catch (error) {
            message.error("余额不足，支付失败。请尽快联系供货商充值。");
        }
    }, [onSuccess]);

    if (!order) {
        return null;
    }

    return (
        <Button type="primary" ghost size="small" onClick={onPayClick} loading={request.loading}>
            去支付
        </Button>
    );
};

export default React.memo(PayOrderButton);
